// Persona preselected on scenario forms: "Typical Male Caller", the predefined
// persona every workspace shares in prod (backend Persona::DEFAULT_NAME, seeded
// by db/seeds/personas_typical_baseline.rb). If it's missing, nothing is
// preselected and the user picks one.
export const DEFAULT_PERSONA_NAME = "Typical Male Caller";

const normalize = (name) => (name || "").trim().toLowerCase();

export const findDefaultPersona = (personas) => {
  if (!Array.isArray(personas)) return undefined;
  return personas.find((p) => normalize(p.name) === normalize(DEFAULT_PERSONA_NAME));
};
